<template>
  <nav class="layout-footer footer" :class="getLayoutFooterBg()">
    <div class="container-fluid container-p-x pb-3 pt-3">
        <div class="float-right hidden-xs">
        Created by Abdullah Haydar
      </div>
      <strong>Copyright © 2024 <a href="https://edusystem.co.za"><b>Edu</b>System</a>.</strong> All rights reserved.
    </div>
  </nav>
</template>

<script>
export default {
  name: 'app-layout-footer',

  methods: {
    getLayoutFooterBg () {
      return `bg-${this.layoutFooterBg}`
    }
  }
}
</script>
